<!-- NotesApp source file: card.component.html -->
<div class="flex flex-wrap">
    <div class="" *ngFor="let project of projects">
        <!-- card -->
        <div class="w-sm flex-grow-0 flex-shrink-0 m-2 border-2 border-primary rounded-md"
            *ngIf="calculateItemCount(project.ID) > 0">
            <!-- card header-->
            <div class="h-7 font-bold text-center border border-[var(--borderColor)] text-black dark:text-white bg-primary"
                (click)="clickCardHeader(project)">
                <div class="">{{ project.Name }}</div>
            </div>
            <div class="h-72 max-h-72 overflow-y-scroll">
                <table class="flex-col max-h-20 flex-nowrap">
                    <tbody class="">
                        <tr class="h-8 mx-20 hover:bg-primary-400 hover:border-red-500 cursor-pointer bg-primary-100"
                            *ngFor="let row of getLastModifiedNotes(project.ID)" (click)="clickRow(row)" [ngClass]="{
                                'bg-[var(--project5Color)]': row.ProjectName === 'Work',
                                'bg-[var(--project1Color)]': row.ProjectName === 'NotesApp',
                                'bg-[var(--project2Color)]': row.ProjectName === 'Vivi/Olivia',
                                'bg-[var(--project3Color)]': row.ProjectName === 'Shopping',
                                'font-bold': row.Status === 'Next Action',
                                'italic text-[var(--textColorFaded)]': row.Status === 'Completed' || row.Status === 'Obsolete' 
                                    || row.Status === 'Cancelled' || row.Status === 'Expired'
                                }">
                            <td class="px-2 ml-20 border border-[var(--borderColor)]" [ngClass]="{'!bg-orange-300': row.syncStatus === 'updated',
                                    '!bg-red-600': row.syncStatus === 'new',
                                    '!line-through text-red-600': row.syncStatus === 'deleted'
                                  }">

                                <a id="EditLink" routerLink="/edit/{{row?._id}}">
                                    <i class="pi pi-pen-to-square"></i></a>
                            </td>
                            <td class="w-96 whitespace-normal px-2 border border-[var(--borderColor)]"
                                [ngClass]="{'!line-through text-red-600': row.syncStatus === 'deleted',
                                                  '!text-red-500': row.syncStatus !== 'synced' && row.syncStatus !== 'deleted'}">
                                {{ this.getNoteYearPrefix(row) }}
                                {{ row.Title }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>